export default "__VITE_ASSET__2aeded73__"